<template>
  <div class="about">
    <h1>Noice</h1>
  </div>
</template>
